import { CacheHandler } from 'reusable/utils/cache'

export const meetingCache = {
   // String of documentId's
   feedback: new CacheHandler<string[]>({ key: 'meeting:feedback', cacheLocation: 'localStorage' }),
   // Tracks which deliverable versions have been viewed: { "meetingId:type": "deliverableId" }
   viewedDeliverables: new CacheHandler<Record<string, string>>({ key: 'meeting:viewedDeliverables', cacheLocation: 'localStorage', useRawKey: true }),
   // ISO timestamp of when sign up completed (for TTV tracking).
   ttvInsightsCompletedAt: new CacheHandler<string>({ key: 'meeting:ttvInsightsCompletedAt', cacheLocation: 'localStorage' }),
   // Distinct meeting IDs left within TTV window (for TTV milestone tracking)
   ttvDistinctMeetingIds: new CacheHandler<string[]>({ key: 'meeting:ttvDistinctMeetingIds', cacheLocation: 'localStorage' }),
   // Set to true once TTV milestone has fired or window expired (prevents re-firing)
   ttvMilestoneFired: new CacheHandler<boolean>({ key: 'meeting:ttvMilestoneFired', cacheLocation: 'localStorage' }),
}
